import { Colors } from "../../../consts/Colors";

export default class ScrollBar extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        this.scene = scene;
        scene.add.existing(this);

        // Ajout barre
        this.barreScroll = this.scene.add.rexRoundRectangle(0, 0, 8, 50, 4, Colors.Elmt.DarkGrey).setOrigin(0.5, 0);
        this.add(this.barreScroll);

        this.setSize(this.barreScroll.width, 800);

    }
}